module.exports = __webpack_public_path__ + "static/img/home-banner.c38b004.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-banner.png
// module id = /0JV
// module chunks = 122